import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const OpeningStockDialogSection = ({ ctx }) => {
  const {
    handleOpeningStockSubmit,
    materials,
    openingStockDialogOpen,
    openingStockForm,
    setOpeningStockDialogOpen,
    setOpeningStockForm
  } = ctx;
  return (
    <>
      <Dialog open={openingStockDialogOpen} onOpenChange={setOpeningStockDialogOpen}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle className="font-heading text-xl">Add Opening Stock</DialogTitle>
          </DialogHeader>
          <form onSubmit={handleOpeningStockSubmit} className="space-y-4 mt-4">
            <div className="bg-blue-50 border border-blue-200 rounded-sm p-3">
              <p className="text-sm text-blue-800">
                <strong>Note:</strong> Use this to add stock that was already available before starting to use the system. 
                This does not require a material requirement.
              </p>
            </div>
            
            <div>
              <label className="block text-xs font-medium text-slate-700 mb-2 uppercase tracking-widest">Select Material *</label>
              <select
                required
                value={openingStockForm.material_id}
                onChange={(e) => setOpeningStockForm({ ...openingStockForm, material_id: e.target.value })}
                className="w-full px-4 py-2 border border-slate-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-primary"
              >
                <option value="">Select Material</option>
                {materials.map((m) => (
                  <option key={m.id} value={m.id}>
                    {m.name} ({m.unit}) - Current Stock: {m.current_stock || 0}
                  </option>
                ))}
              </select>
            </div>
            
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-xs font-medium text-slate-700 mb-2 uppercase tracking-widest">Quantity *</label>
                <input
                  type="number"
                  step="0.01"
                  required
                  min="0.01"
                  value={openingStockForm.quantity}
                  onChange={(e) => setOpeningStockForm({ ...openingStockForm, quantity: e.target.value })}
                  className="w-full px-4 py-2 border border-slate-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-primary font-mono"
                  placeholder="Enter quantity"
                />
              </div>
              <div>
                <label className="block text-xs font-medium text-slate-700 mb-2 uppercase tracking-widest">Rate (₹)</label>
                <input
                  type="number"
                  step="0.01"
                  value={openingStockForm.rate}
                  onChange={(e) => setOpeningStockForm({ ...openingStockForm, rate: e.target.value })}
                  className="w-full px-4 py-2 border border-slate-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-primary font-mono"
                  placeholder="Optional"
                />
              </div>
            </div>
            
            <div>
              <label className="block text-xs font-medium text-slate-700 mb-2 uppercase tracking-widest">Remarks</label>
              <textarea
                value={openingStockForm.remarks}
                onChange={(e) => setOpeningStockForm({ ...openingStockForm, remarks: e.target.value })}
                className="w-full px-4 py-2 border border-slate-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-primary"
                rows="2"
                placeholder="e.g., Stock from previous site, Transferred from warehouse"
              />
            </div>
            
            <div className="flex justify-end space-x-3 pt-4">
              <button type="button" onClick={() => setOpeningStockDialogOpen(false)} className="btn-outline">Cancel</button>
              <button type="submit" className="btn-primary">Add Opening Stock</button>
            </div>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default OpeningStockDialogSection;
